export default __webpack_public_path__ + "static/media/Me2.efe042f2.png";